import {
  SET_MAIN_FOP_COLLECTION_MAX_DISPLAY_FOPS,
  OPEN_MOBILE_REFINE_BY,
  CLOSE_MOBILE_REFINE_BY,
  OPEN_CLUSTER_SECTION,
  COLLAPSE_CLUSTER_SECTION,
  OPEN_FILTER_SECTION,
  COLLAPSE_FILTER_SECTION,
  ADD_RECOMMENDED_FOP_COLLECTION,
  SET_RELATED_SEARCH_PRODUCTS,
  SET_ENHANCED_CATALOGUE_PAGE_VISIBLE_BANNER_INDEX,
  OPEN_QUICK_MENU,
  CLOSE_QUICK_MENU,
  SET_RELATED_CATEGORIES,
} from '../actions/catalogue'; // TODO maybe should be moved to actions/productsPage ?
import { ADD_CITRUS_BANNER } from '../actions/citrusad';

import { setRelatedCategories, setRelatedSearchProducts } from './productsPage/relatedSearch';
import { openQuickMenu, closeQuickMenu } from './productsPage/quickMenu';
import { addRecommendedFopCollection, setMainFopCollectionMaxDisplayFops } from './productsPage/mainFopCollection';
import { openMobileRefineBy, closeMobileRefineBy } from './productsPage/refineByChange';
import { openFilterSection, collapseFilterSection } from './productsPage/filterChange';
import { openClusterSection, collapseClusterSection } from './productsPage/clusterSection';
import { enhancedCataloguePageBanner } from './productsPage/enhancedCataloguePageBanner';
import { addCitrusBanner } from './productsPage/citrusAdBanners';

const ACTIONS = {
  [OPEN_QUICK_MENU]: openQuickMenu,
  [CLOSE_QUICK_MENU]: closeQuickMenu,
  [SET_MAIN_FOP_COLLECTION_MAX_DISPLAY_FOPS]: setMainFopCollectionMaxDisplayFops,
  [OPEN_MOBILE_REFINE_BY]: openMobileRefineBy,
  [CLOSE_MOBILE_REFINE_BY]: closeMobileRefineBy,
  [OPEN_FILTER_SECTION]: openFilterSection,
  [COLLAPSE_FILTER_SECTION]: collapseFilterSection,
  [OPEN_CLUSTER_SECTION]: openClusterSection,
  [COLLAPSE_CLUSTER_SECTION]: collapseClusterSection,
  [ADD_RECOMMENDED_FOP_COLLECTION]: addRecommendedFopCollection,
  [SET_RELATED_CATEGORIES]: setRelatedCategories,
  [SET_RELATED_SEARCH_PRODUCTS]: setRelatedSearchProducts,
  [SET_ENHANCED_CATALOGUE_PAGE_VISIBLE_BANNER_INDEX]: enhancedCataloguePageBanner,
  [ADD_CITRUS_BANNER]: addCitrusBanner,
};

export default (state, action) => (ACTIONS[action.type] ? ACTIONS[action.type]({ state, action }) : state);
